import React, { useEffect, useState } from "react";
import api from "../api"; // axios 인스턴스(Authorization 헤더 포함)
import styles from "./StaffContacts.module.css";
import { isActiveStaff } from "../utils/contractEnded";

const emptyForm = {
  id: null, user_id: "", name: "", email: "",
  position: "", mobile: "", direct_phone: "", memo: ""
};

export default function StaffContacts() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(emptyForm);
  const [me, setMe] = useState(null);

  const load = async () => {
    const [listRes, meRes] = await Promise.all([
      api.get("/staff-contacts/"),
      api.get("/auth/me/"),
    ]);
    setRows(listRes.data);
    setMe(meRes.data);
  };

  useEffect(() => { load(); }, []);

  const filtered = rows.filter(r => {
    // 이름이 빈 문자열, "테스트", 계약종료(서버 판정 is_contract_ended) 제외
    const name = r.name || "";
    if (!name || name === "테스트" || !isActiveStaff(r)) {
      return false;
    }
  
    // 검색어 필터
    const t = (q || "").toLowerCase();
    return [r.name, r.position, r.mobile, r.direct_phone, r.email, r.memo]
      .some(v => (v || "").toLowerCase().includes(t));
  });

  const canEdit = (row) => {
    if (!me) return false;
    return me.is_staff || me.id === row.user_id;
  };

  const openNew = () => { setForm(emptyForm); setOpen(true); };
  const openEdit = (row) => { setForm({...row, user_id: row.user_id}); setOpen(true); };

  const save = async () => {
    if (form.id) {
      await api.patch(`/staff-contacts/${form.id}/`, {
        position: form.position,
        mobile: form.mobile,
        direct_phone: form.direct_phone,
        memo: form.memo,
      });
    } else {
      // 새로 만들기는 관리자만 가능(백엔드 권한)
      await api.post(`/staff-contacts/`, {
        user_id: Number(form.user_id),
        position: form.position,
        mobile: form.mobile,
        direct_phone: form.direct_phone,
        memo: form.memo,
      });
    }
    setOpen(false);
    await load();
  };

  const remove = async (row) => {
    if (!window.confirm("삭제할까요?")) return;
    await api.delete(`/staff-contacts/${row.id}/`);
    await load();
  };

  return (
    <div className={styles.wrap}>
      <h1>임직원 연락망</h1>

      <div className={styles.toolbar}>
        <input
          className={styles.search}
          placeholder="검색: 성명/직위/연락처/이메일"
          value={q}
          onChange={(e)=>setQ(e.target.value)}
        />
        <button className={styles.btn} onClick={openNew}>추가</button>
      </div>

      <div className={styles.tableWrap}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>성명</th><th>직위</th><th>휴대전화</th><th>직통전화</th><th>이메일</th><th>비고</th><th></th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(r => (
              <tr key={r.id}>
                <td>{r.name}</td>
                <td>{r.position}</td>
                <td>{r.mobile}</td>
                <td>{r.direct_phone}</td>
                <td>{r.email}</td>
                <td>{r.memo}</td>
                <td className={styles.actions}>
                  {canEdit(r) && (
                    <>
                      <button className={styles.linkBtn} onClick={()=>openEdit(r)}>수정</button>
                      {/* <button className={styles.linkBtnDanger} onClick={()=>remove(r)}>삭제</button> */}

                    </>
                  )}
                </td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr><td colSpan={7} className={styles.empty}>검색 결과가 없습니다.</td></tr>
            )}
          </tbody>
        </table>
      </div>

      {open && (
        <div className={styles.modal}>
          <div className={styles.modalBody}>
            <h3>{form.id ? "연락처 수정" : "연락처 추가"}</h3>

            {!form.id && (
              <div className={styles.field}>
                <label>유저 ID(회원가입된 계정)</label>
                <input
                  value={form.user_id}
                  onChange={e=>setForm({...form, user_id:e.target.value})}
                  placeholder="예: 12"
                />
                <div className={styles.hint}>* 관리자만 추가 가능. 수정/삭제는 본인 또는 관리자.</div>
              </div>
            )}

            <div className={styles.field}><label>직위</label>
              <input value={form.position||""} onChange={e=>setForm({...form, position:e.target.value})} />
            </div>
            <div className={styles.field}><label>휴대전화</label>
              <input value={form.mobile||""} onChange={e=>setForm({...form, mobile:e.target.value})} />
            </div>
            <div className={styles.field}><label>직통전화</label>
              <input value={form.direct_phone||""} onChange={e=>setForm({...form, direct_phone:e.target.value})} />
            </div>
            <div className={styles.field}><label>비고</label>
              <textarea value={form.memo||""} onChange={e=>setForm({...form, memo:e.target.value})} />
            </div>

            <div className={styles.modalActions}>
              <button className={styles.btn} onClick={save}>저장</button>
              <button className={styles.btnGhost} onClick={()=>setOpen(false)}>닫기</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
